function view (path) {
  return () => import(/* webpackChunkName: 'shared-v2' */ '@/views/shared/' + path + '.vue').then(m => m.default || m) // eslint-disable-line prefer-template
}

const RShared = [
  {
    path: '/sign-in',
    component: view('SignIn'),
    name: 'shared.login',
    meta: {
      layout: 'auth'
    }
  },
  {
    path: '/dashboard',
    component: view('Dashboard'),
    name: 'shared.dashboard',
    meta: {
      breadcrumb: [
        {
          text: 'Dashboard',
          active: true
        }
      ]
    }
  },
  {
    path: '/auth/:provider/callback',
    component: view('SingleSignOn'),
    name: 'shared.sso',
    meta: {
      layout: 'sso'
    }
  }
]

const RSharedPrivate = [
  {
    path: '/force-password-change',
    component: view('ForcePasswordChange'),
    name: 'shared.force-password-change',
    meta: {
      breadcrumb: [
        {
          text: 'Security'
        },
        {
          text: 'Change Password',
          active: true
        }
      ]
    }
  },
  {
    path: '/account/settings',
    component: view('account-settings/Base'),
    name: 'shared.account.settings',
    meta: {
      breadcrumb: [
        {
          text: 'Account'
        },
        {
          text: 'Settings',
          active: true
        }
      ]
    }
  }
]

const RShared404 = [
  {
    path: '*',
    component: view('404'),
    name: 'shared.page-not-found',
    meta: {
      layout: 'auth'
    }
  }
]

export default RShared.concat(
  RSharedPrivate,
  RShared404
)
